import { Navigate, Outlet } from "react-router-dom";
import { AsyncAccessTokenDecoder } from "../utils/accessTokenDecoder";
import routesName from "../constants/routesName";

const MisRoutes = () => {
  const decodeToken = AsyncAccessTokenDecoder();
  return decodeToken?.Roles === "Super Admin" ||
    decodeToken?.Roles === "Management" ? (
    <>
      <Outlet />
    </>
  ) : (
    <>
      <Navigate to={routesName.hospitalManagementPage} />
    </>
  );
};

export default MisRoutes;
